var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclusiveTagIcnSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1316_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.8 111.089c50.739 49.33 96.182 84.881 101.501 79.403 5.318-5.477-31.502-49.908-82.24-99.239C60.323 41.923 14.88 6.373 9.561 11.85c-5.319 5.477 31.501 49.908 82.24 99.239z",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h202.872v203L92.899 93.963 0 0z",
    fill: "#000",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.997 39.085C154.558 29.16 147.902 23 147.902 23s-6.663 6.16-17.087 16.085c-5.505 5.246-17.887 18.255-17.887 31.198-.003 3.409 1.166 6.724 3.327 9.44 2.162 2.715 5.197 4.681 8.642 5.598a17.13 17.13 0 0010.436-.523c3.325-1.256 6.127-3.516 7.978-6.432a1.7 1.7 0 01.577-.44c.223-.106.468-.163.717-.17.838 0 1.607.566 1.523 1.263-.632 4.65-3.373 16.114-14.209 19.981h31.982c-10.828-3.867-13.57-15.33-14.202-19.981-.091-.726.678-1.263 1.523-1.263.248.008.491.067.713.172.222.105.418.255.574.438 1.852 2.913 4.654 5.169 7.977 6.422a17.137 17.137 0 0010.43.52c3.443-.915 6.477-2.88 8.638-5.593 2.161-2.713 3.33-6.026 3.33-9.432 0-12.929-12.381-25.938-17.879-31.198",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.91 40l4.479 13.372h14.505l-11.731 8.264L159.65 75l-11.74-8.257L136.179 75l4.479-13.364-11.74-8.264h14.521L147.91 40z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.49 16.5l115.927 116",
    stroke: "url(#paint0_linear_1316_2)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1316_2",
    x1: 14.99,
    y1: 16.427,
    x2: 189.272,
    y2: 189.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h203v203H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1316_2",
    x: -15.95,
    y: -13.707,
    width: 234.761,
    height: 229.756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_1316_2"
  })))));
}

SvgExclusiveTagIcnSquare.displayName = 'ExclusiveTagIcnSquare';
export default SvgExclusiveTagIcnSquare;